// ********************************************************
// System
// Handles stuff like loading log.
// ********************************************************

import * as Backend from '@/core/backend'

export async function getLog () {
  const res = await Backend.callApi({
    apiName: 'SysInfo.GetLog'
  })
  return res
}

export async function getTest (params) {
  const res = await Backend.callApi({
    apiName: 'SysInfo.GetTest',
    inputData: {
      Data1: params.Data1,
      Data2: params.Data2
    }
  })
  return res
}
